const MatchDuelsPageReducer = (state, action) => {
  switch (action.type) {
    case 'MATCH_DUELS_STATS_FETCHING':
      return {...state, stats: {...state.stats, isFetching: true}};
    case 'MATCH_DUELS_STATS_UPDATE':
      return {...state, stats: {...state.stats, isFetching: false, data: action.data}};
    case 'MATCH_DUELS_STATS_ERROR':
      return {...state, stats: {...state.stats, isFetching: false, error: action.data}};
    case 'MATCH_DUELS_MATCHES_FETCHING':
      return {...state, matches: {...state.matches, isFetching: true}};
    case 'MATCH_DUELS_MATCHES_UPDATE':
      const matches = {...state.matches};
      matches.items = matches.items.concat(action.data.items);
      matches.nextUrl = action.data.nextUrl;
      matches.isFetching = false;
      return {...state, matches};
    case 'MATCH_DUELS_MATCHES_ERROR':
      return {...state, matches: {...state.matches, error: action.data, nextUrl: null, isFetching: false}};
    default:
      return state;
  }
};

export {MatchDuelsPageReducer};
